import React, { useState } from 'react';
import Slider from 'react-slick';
import CardComponent from '../components/CardComponent';
import { Box, Typography, Container, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const Portfolio = () => {
  const { t } = useTranslation();
  const [slider1, setSlider1] = useState(null);
  const [slider2, setSlider2] = useState(null);

  const projects = t('portfolio.projects', { returnObjects: true }); 

  const settingsMain = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: slider2,
    adaptiveHeight: true,
  };

  const settingsText = {
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: slider1,
    arrows: false,
    adaptiveHeight: true,
  };

  return (
    <Box sx={{ bgcolor: '#0B1220', py: { xs: 8, md: 12 } }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: { xs: 3, md: 5 } }}>
          <Typography
            variant="h4"
            sx={{
              fontSize: { xs: '1.8rem', md: '2.6rem' },
              fontWeight: 800,
              fontFamily: 'Sora, sans-serif',
              color: '#F8FAFC',
              mb: 1,
            }}
          >
            {t('portfolio.title')}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Source Sans 3, sans-serif',
              color: '#C7D2FE',
              fontSize: { xs: '1rem', md: '1.2rem' },
              maxWidth: 720,
              mx: 'auto',
            }}
          >
            {t('portfolio.subtitle')}
          </Typography>
        </Box>

        <Box sx={{ maxWidth: '100%', margin: '0 auto' }}>
          <Slider {...settingsMain} ref={(slider) => setSlider1(slider)}>
            {projects.map((project, index) => (
              <CardComponent
                key={index}
                title={project.title}
                description={project.description}
                image={project.image}
                link={project.link}
              />
            ))}
          </Slider>
        </Box>

        <Box
          sx={{
            maxWidth: { xs: '100%', md: '70%' },
            mx: 'auto',
            mt: { xs: 4, md: 4 },
            '& .slick-slide > div': { display: 'flex', justifyContent: 'center' },
          }}
        >
          <Slider {...settingsText} ref={(slider) => setSlider2(slider)}>
            {projects.map((project, index) => (
              <Box
                key={index}
                sx={{
                  textAlign: 'left',
                  padding: { xs: '1rem', md: '1.5rem' },
                  margin: '0 auto',
                  maxWidth: '100%',
                  background: 'rgba(15,23,42,0.6)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: 3,
                  boxShadow: '0 10px 30px rgba(0,0,0,0.35)',
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: { xs: '1.3rem', md: '1.6rem' },
                    marginBottom: '0.35rem',
                    fontFamily: 'Sora, sans-serif',
                    color: '#F8FAFC',
                    fontWeight: 700,
                  }}
                >
                  {project.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: { xs: '0.95rem', md: '1.05rem' },
                    fontFamily: 'Source Sans 3, sans-serif',
                    color: '#A5B4FC',
                    marginBottom: '0.75rem',
                  }}
                >
                  {project.description}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { xs: '0.95rem', md: '1.05rem' },
                    textAlign: 'left',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                    fontFamily: 'Source Sans 3, sans-serif',
                    color: '#E2E8F0',
                    lineHeight: 1.75,
                  }}
                >
                  {project.detailedDescription}
                </Typography>
                {project.link && (
                  <Box sx={{ mt: 2 }}>
                    <Button
                      href={project.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        textTransform: 'none',
                        fontFamily: 'Sora, sans-serif',
                        fontWeight: 700,
                        color: '#06B6D4',
                        borderColor: 'rgba(6,182,212,0.35)',
                        '&:hover': { borderColor: '#06B6D4', background: 'rgba(6,182,212,0.08)' },
                      }}
                      variant="outlined"
                    >
                      {t('portfolio.visitLink')}
                    </Button>
                  </Box>
                )}
              </Box>
            ))}
          </Slider>
        </Box>
      </Container>
    </Box>
  );
};

export default Portfolio;
